module.exports = __webpack_public_path__ + "static/img/weibo.d41d4c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weibo.png
// module id = 5WfB
// module chunks = 15